// extracted by mini-css-extract-plugin
export default {"root":"_3f49w","loader":"_1VcBx"};